import { ActionTypes } from './action-types';

export enum AUTHENTICATION_STATE {
    LOGGED_IN,
    LOGIN_FAILED,
    LOGIN_PROMPTED,
    VERIFYING,
    LOGGED_OUT,
}

/* tslint:disable:no-empty-interface */
export interface ISession {
    id: string
    state: AUTHENTICATION_STATE
}

export interface IUser {
    id: string,
    email: string,
    firstName: string,
    lastName: string,
    date: string, // hmm :()
    isConfirmed: boolean,
    currentDeviceId: string,
    isPending: boolean,
    level: number
}

export type ActionObject =
    {
        type: ActionTypes.USER_LOGIN_FAILURE
    } | {
        type: ActionTypes.USER_LOGIN_REQUEST
    } | {
        type: ActionTypes.USER_LOGIN_SUCCESS,
        session: string
    } | {
        type: ActionTypes.USER_LOGOUT_SUCCESS
    }



// WEBPACK FOOTER //
// ./src/types/authentication.ts